import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-container" }
const _hoisted_2 = ["id", "name", "value", "disabled"]

import TextBase, { TextColor, TextType } from '@/design-system/atoms/TextBase.vue'
import { computed } from 'vue'

export type LabelConfig = {
  type?: TextType
  color?: TextColor
}

export type CheckboxProps = {
  label: string
  styling: 'fill' | 'outline'
  labelConfig?: LabelConfig
  color?: string
  initial?: boolean
  disabled?: boolean
  borderColor?: string
}

type Emits = {
  (e: 'change', checked: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxComponent',
  props: {
    label: {},
    styling: {},
    labelConfig: {},
    color: {},
    initial: { type: Boolean },
    disabled: { type: Boolean },
    borderColor: {}
  },
  emits: ["change"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "1adc9c70": (_ctx.color ?? 'currentColor'),
  "2c5f6688": (_ctx.borderColor ?? 'currentColor')
}))

const props = __props


const checked = computed<boolean>(() => props.initial ?? false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: _ctx.label,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      type: "checkbox",
      name: _ctx.label,
      value: _ctx.label,
      disabled: _ctx.disabled,
      class: _normalizeClass({ fill: _ctx.styling === 'fill', outline: _ctx.styling === 'outline' }),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', checked.value)))
    }, null, 42, _hoisted_2), [
      [_vModelCheckbox, checked.value]
    ]),
    _createVNode(TextBase, {
      text: _ctx.label,
      type: _ctx.labelConfig?.type,
      disabled: _ctx.disabled,
      style: { display: 'flex', 'align-items': 'center' }
    }, null, 8, ["text", "type", "disabled"])
  ]))
}
}

})